export default __webpack_public_path__ + "static/media/20s_bg_desktop.b610838b.jpg";